/* Voisson product section (sections/voisson-product.liquid). Everything here is an enhancement: the
   photos, prices and the Add to bag form all work from the markup. The Interactopus cart catches the
   form's submit; this file only keeps the chosen variant, the photo dots and the slim bar in step, and
   remembers the shopper's picks for the next product page (size memory, below). */
(() => {
  /* Focus that a script moves (a window opening onto its cross, closing back onto its opener): after a finger or mouse
     press (html[data-io-pointer], layout/theme.liquid) it asks for no ring, where the browser takes that wish; after a key
     it asks nothing, so a keyboard user sees where they are. voisson.css hides the ring for browsers that ignore it. */
  const quietFocus = () => document.documentElement.hasAttribute('data-io-pointer') ? { preventScroll: true, focusVisible: false } : { preventScroll: true };
  const dark = (c) => { const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})/i.exec(c || ''); if (!m) return false; const [r, g, b] = m.slice(1).map((h) => parseInt(h, 16)); return r * .299 + g * .587 + b * .114 < 128; };
  /* SIZE MEMORY v1.1 (founder 2026-09-27: "once a size is selected on a product it will be preselected on other
     products"; product pages and the Conversion Lift carousel's size sheet share this one memory, same contract):
     sessionStorage 'io:size:' + Shopify.shop = {"v":1,"o":{"<option name as shown>":"<value as shown>"}}, at most
     8 names (the oldest written dropped first; a write re-inserts its name last), names and values at most 60
     characters, any other shape ignored and overwritten on the next write. v1.1: a name that reads as an array index
     ("0", "7", "12") is never remembered — refused on write, ignored on read — because an object always lists such
     names first, which would break "oldest dropped first". The stored "v" stays 1. Written only by the shopper's own
     tap on a value; read once as a product page opens. Every read and write can fail: then there is simply no memory.
     No network, no visitor id; gone when the tab closes. */
  const MEM = () => 'io:size:' + (typeof window.Shopify?.shop === 'string' ? Shopify.shop : '');
  const ok60 = (k, v) => typeof k === 'string' && typeof v === 'string' && !!k && !!v && k.length <= 60 && v.length <= 60 && !/^(0|[1-9]\d*)$/.test(k);
  const memory = () => { try { const m = JSON.parse(sessionStorage.getItem(MEM())); if (m && m.v === 1 && m.o && typeof m.o === 'object' && !Array.isArray(m.o)) return m.o; } catch (e) { /* no memory */ } return {}; };
  const remember = (name, val) => { try { if (!ok60(name, val)) return; const o = memory(), out = {}; delete o[name]; o[name] = val; Object.keys(o).filter((k) => ok60(k, o[k])).slice(-8).forEach((k) => { out[k] = o[k]; }); sessionStorage.setItem(MEM(), JSON.stringify({ v: 1, o: out })); } catch (e) { /* no memory */ } };
  const init = (el) => {
    if (el.__vp) return; el.__vp = 1;
    const $ = (s) => el.querySelector(s), $$ = (s) => [...el.querySelectorAll(s)];
    const track = $('.vp-track'), slides = $$('.vp-slide'), dotRail = $('.vp-dots'), dots = $$('.vp-dots button'), film = $$('.vp-film button'), filmRail = $('.vp-film'), filmWrap = $('.vp-film-wrap'), count = $('[data-vp-count]'), back = $('.vp-gal [data-photo-back]'), gallery = $('.vp-gal');
    const photoPrev = $('[data-vp-prev]'), photoNext = $('[data-vp-next]'), markerPrev = $('[data-vp-marker-prev]'), markerNext = $('[data-vp-marker-next]'), filmPrev = $('[data-vp-film-prev]'), filmNext = $('[data-vp-film-next]');
    const stackRow = $('.vp-review-stack-row'), stackOpen = $('[data-vp-stack-open]'), stackTray = $('[data-vp-stack-tray]');
    const stackPrev = $('[data-vp-stack-prev]'), stackNext = $('[data-vp-stack-next]'), stackFaces = $$('.vp-review-stack-face'), stackItems = $$('.vp-review-stack-tray button');
    /* A bubble picture still missing after 100 ms shows its grey circle, then fades in; one that arrives sooner simply
       appears (founder 2026-10-08: they "appear late and look broken"; "if they load quickly don't add the fade effect").
       Only script adds the wait, so without script the pictures simply show. */
    const fadeIn = (face, img) => {
      clearTimeout(face.vpFade); face.classList.remove('is-loading');
      if (img.complete && img.naturalWidth) return;
      const done = () => { clearTimeout(face.vpFade); face.classList.remove('is-loading'); };
      face.vpFade = setTimeout(() => { if (!(img.complete && img.naturalWidth)) face.classList.add('is-loading'); }, 100);
      img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
    };
    stackFaces.forEach((face) => { const img = face.querySelector('img'); if (img) fadeIn(face, img); });
    /* The tray holds the same files the bubble swaps in on an arrow press (same widths and sizes, so the same download).
       Fetch them once the lead photo is done, so a press shows its pictures at once instead of blank circles. */
    const warmTray = () => stackItems.forEach((b) => { const im = b.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; });
    if (stackItems.length) {
      if (!el.hasAttribute('data-vp-hold')) warmTray();
      else new MutationObserver((_, mo) => { if (!el.hasAttribute('data-vp-hold')) { mo.disconnect(); warmTray(); } }).observe(el, { attributes: true, attributeFilter: ['data-vp-hold'] });
    }
    const follow = el.dataset.bgMode === 'follow', root = document.documentElement.style;
    const top = el.getBoundingClientRect().top + scrollY; if (top < 240) el.style.setProperty('--vp-top', top + 'px');
    const tile = $('.vp-tile'), lead = $('.vp-full');
    if (tile && lead) { const drop = () => tile.remove(); lead.complete ? drop() : lead.addEventListener('load', drop, { once: true }); }
    /* the section's hold script gives each video its poster when the other pictures may load; when nothing is held (that
       script never ran: inline scripts blocked, or the section's HTML inserted later), the poster goes back now */
    if (!el.hasAttribute('data-vp-hold')) {
      $$('video[data-poster]').forEach((v) => { if (!v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); });
      $$('img.vp-poster[data-src]').forEach((i) => { if (!i.getAttribute('src')) i.setAttribute('src', i.dataset.src); });
    }
    let cur = 0;
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    /* The rating is a reorderable app block. Move its wrapper beside the stack only on mobile Caption,
       and restore its exact place on desktop or when the editor changes the layout. Never nest controls in its link. */
    if (stackRow) {
      const phone = matchMedia('(max-width: 899px)');
      const rating = $('.vp-app:has([data-io-rating-block])');
      if (rating) {
        const place = document.createComment('rating block place'); rating.before(place);
        const arrange = () => {
          if (phone.matches && el.classList.contains('vp--ph-caption')) stackRow.prepend(rating);
          else if (place.parentNode) place.after(rating);
        };
        arrange(); phone.addEventListener('change', arrange);
      }
    }
    const revealStackItem = (i) => {
      if (!stackTray || stackTray.hidden || !stackItems[i]) return;
      const a = stackItems[i].getBoundingClientRect(), b = stackTray.getBoundingClientRect();
      if (a.left < b.left) stackTray.scrollLeft += a.left - b.left - 4;
      else if (a.right > b.right) stackTray.scrollLeft += a.right - b.right + 4;
    };
    const setStackOpen = (open) => {
      if (!stackTray || !stackOpen) return;
      if (open) stackItems.forEach((item) => { const img = item.querySelector('img'); if (img) img.loading = 'eager'; });
      stackTray.hidden = !open;
      stackOpen.setAttribute('aria-expanded', String(open));
      if (open) requestAnimationFrame(() => revealStackItem(cur));
    };
    const gridMode = () => el.classList.contains('vp--lp-grid') && matchMedia('(min-width: 900px)').matches;
    const filmArrows = () => {
      if (!filmRail || !filmWrap) return;
      const overflow = filmRail.scrollWidth > filmRail.clientWidth + 2;
      filmWrap.classList.toggle('vp-film-wrap--fits', !overflow);
      if (filmPrev) filmPrev.disabled = !overflow || filmRail.scrollLeft <= 2;
      if (filmNext) filmNext.disabled = !overflow || filmRail.scrollLeft >= filmRail.scrollWidth - filmRail.clientWidth - 2;
    };
    const backTone = (i) => {
      const toneIndex = gridMode() ? 0 : i;
      if (!back || !slides[toneIndex]) return;
      const contrast = (onDark) => {
        back.classList.toggle('photo-back--on-dark', onDark);
        const ink = onDark ? '#fbf9f6' : '#292824';
        gallery?.style.setProperty('--vp-photo-contrast', ink);
        el.style.setProperty('--vp-photo-contrast', ink);
      };
      contrast(dark(slides[toneIndex].dataset.bg));
      const image = slides[toneIndex].querySelector('img.vp-img');
      if (!image) return;
      const sample = () => {
        if ((!gridMode() && cur !== i) || !image.naturalWidth) return;
        try {
          const canvas = document.createElement('canvas'); canvas.width = 12; canvas.height = 6;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0, image.naturalWidth * .4, image.naturalHeight * .18, 0, 0, 12, 6);
          const pixels = context.getImageData(0, 0, 12, 6).data;
          let total = 0;
          for (let n = 0; n < pixels.length; n += 4) {
            const alpha = pixels[n + 3] / 255;
            total += (pixels[n] * .299 + pixels[n + 1] * .587 + pixels[n + 2] * .114) * alpha + 243 * (1 - alpha);
          }
          contrast(total / (pixels.length / 4) < 128);
        } catch (_) { /* Cross-origin media keeps the photo-colour choice. */ }
      };
      if (image.complete) sample(); else image.addEventListener('load', sample, { once: true });
    };
    const show = (i) => {
      cur = i;
      dots.forEach((d, k) => { d.classList.toggle('on', k === i); k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
      if (dotRail?.clientWidth && dots[i]) {
        const a = dots[i].getBoundingClientRect(), b = dotRail.getBoundingClientRect();
        if (a.left < b.left) dotRail.scrollBy({ left: a.left - b.left - 4, behavior: motion() });
        else if (a.right > b.right) dotRail.scrollBy({ left: a.right - b.right + 4, behavior: motion() });
      }
      if (count) count.textContent = i + 1;
      film.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      /* photo viewer: in Split and Framed only the photo in view takes Tab (Grid shows them all) */
      slides.forEach((s, k) => { if (s.classList.contains('vp-zoomable')) s.tabIndex = gridMode() || k === i ? 0 : -1; });
      if (photoPrev) photoPrev.disabled = i === 0;
      if (photoNext) photoNext.disabled = i === slides.length - 1;
      if (markerPrev) markerPrev.disabled = i === 0;
      if (markerNext) markerNext.disabled = i === slides.length - 1;
      if ((i === 0 && document.activeElement === stackPrev) || (i === slides.length - 1 && document.activeElement === stackNext)) stackOpen?.focus(quietFocus());
      if (stackPrev) stackPrev.disabled = i === 0;
      if (stackNext) stackNext.disabled = i === slides.length - 1;
      if (stackOpen) stackOpen.setAttribute('aria-label', `Show all ${slides.length} photos, photo ${i + 1} selected`);
      stackItems.forEach((d, k) => { k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
      stackFaces.forEach((face, n) => {
        const item = stackItems[(i + n) % stackItems.length];
        const source = item?.querySelector('img'), target = face.querySelector('img');
        if (source && target) {
          if (source.getAttribute('src') !== target.getAttribute('src')) target.setAttribute('src', source.getAttribute('src'));
          if (source.getAttribute('srcset') !== target.getAttribute('srcset')) target.setAttribute('srcset', source.getAttribute('srcset') || '');
          fadeIn(face, target);
        }
        face.classList.toggle('is-active', n === 0);
        const play = face.querySelector('.vp-review-stack-play');
        if (play) play.hidden = item?.dataset.vpStackVideo !== 'true';
      });
      revealStackItem(i);
      const thumb = film[i];
      if (thumb && filmRail?.clientWidth) {
        const a = thumb.getBoundingClientRect(), b = filmRail.getBoundingClientRect();
        if (a.left < b.left + 2) filmRail.scrollBy({ left: a.left - b.left - 4, behavior: motion() });
        else if (a.right > b.right - 2) filmRail.scrollBy({ left: a.right - b.right + 4, behavior: motion() });
      }
      if (follow && slides[i]) { const c = slides[i].dataset.bg; el.style.setProperty('--vp-grey', c); root.setProperty('--vp-hdr', c); root.setProperty('--vp-hdr-ink', dark(c) ? '#fbf9f6' : '#292824'); }
      backTone(i);
    };
    let gridTargetUntil = 0;
    /* A colour tap lands where the product starts, just under the header (founder 2026-10-08: photo, colours and Add
       to bag in one view, no header). The header keeps out of the way during that jump. */
    const hdRoom = () => { const h = window.__voissonHeader; return h && h.room ? h.room() : 76; };
    const hdHold = () => { const h = window.__voissonHeader; if (h && h.hold) h.hold(); };
    const underHeader = () => Math.max(0, Math.round(el.getBoundingClientRect().top + scrollY - hdRoom()));
    /* The colour tap always shows the whole photo (founder 2026-10-08), even when the browser's own bars leave too
       little room for Add to bag; a size tap is what brings Add to bag into view. */
    const pageAdd = () => $$('[data-vp-add]').find((b) => !b.hasAttribute('data-vp-short') && b.getClientRects().length);
    const go = (i, now, colourTap = false) => {
      if (!track || !slides[i]) return;
      if (gridMode()) {
        gridTargetUntil = performance.now() + (now || motion() === 'auto' ? 100 : 850);
        if (colourTap) {
          const selected = slides[i].getBoundingClientRect(), first = slides[0].getBoundingClientRect();
          const firstRow = Math.abs(selected.top - first.top) < 2;
          const room = hdRoom(), headerRoom = selected.height + room <= innerHeight ? room : 0;
          hdHold();
          window.scrollTo({ top: firstRow ? underHeader() : Math.max(0, selected.top + scrollY - headerRoom), behavior: motion() });
        } else slides[i].scrollIntoView({ block: 'start', behavior: now ? 'auto' : motion() });
        setTimeout(gridActive, now || motion() === 'auto' ? 120 : 900);
      } else {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: now ? 'auto' : motion() });
        if (colourTap) { hdHold(); window.scrollTo({ top: underHeader(), behavior: motion() }); }
      }
      show(i);
    };
    let gridFrame = 0;
    const gridActive = () => {
      if (!gridMode() || performance.now() < gridTargetUntil) return;
      const line = Math.min(innerHeight * .22, 220);
      let best = -1, distance = Infinity;
      slides.forEach((slide, i) => {
        const box = slide.getBoundingClientRect();
        if (box.bottom <= 72 || box.top >= innerHeight - 32) return;
        const d = Math.abs(box.top - line) - (i === cur ? .5 : 0);
        if (d < distance) { best = i; distance = d; }
      });
      if (best >= 0 && best !== cur) show(best);
    };
    const queueGridActive = () => {
      if (gridFrame) return;
      gridFrame = requestAnimationFrame(() => { gridFrame = 0; gridActive(); });
    };
    if (track && slides.length > 1) {
      /* Swiping selects a carousel slide; page scrolling selects the visible row in Gallery grid. */
      const io = new IntersectionObserver((es) => { if (track.scrollWidth <= track.clientWidth + 2) return; es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > .6) show(slides.indexOf(e.target)); }); }, { root: track, threshold: [.6] });
      slides.forEach((s) => io.observe(s));
      dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
      /* Offer engine (vo-offers.js, design 74 on mobile): a slide added inside the picture-hold window joins the slider
         with its dot, so the dots, the count and swiping include it. */
      el.addEventListener('vp:slide-added', (e) => { const sl = e.detail && e.detail.slide, d = e.detail && e.detail.dot; if (!sl || slides.includes(sl)) return; slides.push(sl); io.observe(sl); if (d) { dots.push(d); const k = dots.length - 1; d.addEventListener('click', () => go(k)); } const st = e.detail && e.detail.stack; if (st) { stackItems.push(st); const k = slides.length - 1; st.addEventListener('click', () => { go(k); setStackOpen(false); stackOpen?.focus(quietFocus()); }); } show(cur); });
      /* ...and leaves it again when the offer gives its place back (vo-offers.js galleryUnplace): the slider, its dots and
         the count stay in step (review 2026-10-12) */
      el.addEventListener('vp:slide-removed', (e) => { const sl = e.detail && e.detail.slide, d = e.detail && e.detail.dot, i = sl ? slides.indexOf(sl) : -1; if (i < 0) return; io.unobserve(sl); slides.splice(i, 1); if (d) { const k = dots.indexOf(d); if (k > -1) dots.splice(k, 1); } const st = e.detail && e.detail.stack; if (st) { const k = stackItems.indexOf(st); if (k > -1) stackItems.splice(k, 1); } show(Math.min(cur, slides.length - 1)); });
      film.forEach((d) => d.addEventListener('click', () => go(+d.dataset.go)));
      photoPrev?.addEventListener('click', () => go(cur - 1));
      photoNext?.addEventListener('click', () => go(cur + 1));
      markerPrev?.addEventListener('click', () => go(cur - 1));
      markerNext?.addEventListener('click', () => go(cur + 1));
      stackPrev?.addEventListener('click', () => go(cur - 1));
      stackNext?.addEventListener('click', () => go(cur + 1));
      stackOpen?.addEventListener('click', () => setStackOpen(stackTray.hidden));
      stackItems.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.go); setStackOpen(false); stackOpen?.focus(quietFocus()); }));
      stackTray?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setStackOpen(false); stackOpen?.focus(quietFocus()); } });
      filmPrev?.addEventListener('click', () => filmRail.scrollBy({ left: -Math.max(64, filmRail.clientWidth * .75), behavior: motion() }));
      filmNext?.addEventListener('click', () => filmRail.scrollBy({ left: Math.max(64, filmRail.clientWidth * .75), behavior: motion() }));
      filmRail?.addEventListener('scroll', filmArrows, { passive: true });
      if (filmRail && 'ResizeObserver' in window) new ResizeObserver(filmArrows).observe(filmRail);
      else window.addEventListener('resize', filmArrows);
      window.addEventListener('scroll', queueGridActive, { passive: true });
      window.addEventListener('resize', queueGridActive, { passive: true });
      filmArrows();
    }
    show(0);
    queueGridActive();
    /* Photo viewer (founder 2026-10-08: "the visitors should be able to click on an image to see it bigger"; 2026-10-12:
       a zoom icon under the back link, a pinch on a photo opens it, a satisfying move into the zoom screen, the other
       photos one tap away there, and only the zoom screen loads the full-quality file). It opens from the magnifier under
       the back link (every device), a pinch on a photo (touch screens; a trackpad pinch on a laptop) and, with a mouse
       from 900 px, a click, Enter or Space on a photo. The photo grows from its zPlace on the page into the whole window,
       which takes the photo's own colour (300 ms in, 200 ms back, docs/motion.md; reduced motion: a 100 ms zFade). It
       shows at once from the file the page already has, then from the full-quality 2048 px file (the page's own copies
       may carry a lower quality; the zoom screen never does). Inside: pinch, drag and double-tap zoom up to 4x on touch;
       a click zooms 2.5x and the photo follows the mouse; ctrl/pinch on a trackpad zooms at the pointer. At normal size
       a sideways swipe changes photo and a downward drag closes. The row of small photos, the arrows (mouse only), the
       left/right keys and the count move between photos; videos stay on the page. Escape, the cross or a click beside
       the photo closes it; focus goes back where it was and the gallery shows the photo last viewed. The page itself
       keeps its normal zoom everywhere except on the photos, where a pinch opens this screen instead (blocking page
       zoom everywhere would lock out shoppers who enlarge text, and iPhones ignore that switch anyway). Never in the
       theme editor, where a click selects. */
    const wide = matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)'), shots = slides.filter((s) => s.querySelector('img.vp-img'));
    const zoomBtn = $('[data-vp-zoom]'), zStill = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const EASE_IN = 'cubic-bezier(.16,1,.3,1)', EASE_MOVE = 'cubic-bezier(.65,0,.35,1)', MAX = 4;
    let viewer = null, viewAt = 0, zOpener = null, busy = false, lastType = 'mouse';
    const fileAt = (img, width, keepQuality) => {
      const src = img.currentSrc || img.src;
      try { const u = new URL(src, location.href); u.searchParams.set('width', String(width)); if (!keepQuality) u.searchParams.delete('quality'); return u.href; } catch (e) { return src; }
    };
    const sharp = (img) => fileAt(img, 2048);
    /* founder 2026-10-12: "use 4k only for zoomed in photo". A photo stored bigger than 2048 px (data-w, from the slide)
       loads its full file only once the shopper zooms past 1.6x, where 2048 px stops being sharp; Shopify never makes a
       file bigger than it is, so the 4096 ask returns the stored size (2880 px for the Sunburst 4K photos). */
    const deep = (i) => {
      const s = shots[i];
      if (!s || s.vpDeep || !(+s.dataset.w > 2048)) return;
      s.vpDeep = 'loading';
      const url = fileAt(pageImg(i), 4096), im = new Image();
      im.onload = () => { s.vpDeep = url; if (viewer?.open && viewAt === i) vImg.src = url; };
      im.onerror = () => { s.vpDeep = null; };
      im.src = url;
    };
    /* zoom state of the photo in the zoom screen: scale s, shift x/y in px from the centred, fitted photo */
    const z = { s: 1, x: 0, y: 0 };
    let vImg = null, vStage = null, vShade = null, vUi = null;
    const zBox = () => { const r = vStage.getBoundingClientRect(); return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, W: r.width, H: r.height, w: vImg.offsetWidth, h: vImg.offsetHeight }; };
    const clampZ = () => {
      const b = zBox(), mx = Math.max(0, (z.s * b.w - b.W) / 2), my = Math.max(0, (z.s * b.h - b.H) / 2);
      z.x = Math.min(mx, Math.max(-mx, z.x)); z.y = Math.min(my, Math.max(-my, z.y));
    };
    const zPaint = (glide) => {
      vImg.classList.toggle('is-gliding', !!glide && !zStill());
      vImg.style.transform = z.s === 1 && !z.x && !z.y ? '' : `translate(${z.x}px,${z.y}px) scale(${z.s})`;
      viewer.classList.toggle('is-zoomed', z.s > 1.01);
      if (z.s > 1.6) deep(viewAt);
    };
    /* zoom to scale s keeping the photo point under (mx,my) under it */
    const zoomAt = (s, mx, my, glide) => {
      const b = zBox(), ns = Math.min(MAX, Math.max(1, s));
      const px = (mx - b.cx - z.x) / z.s, py = (my - b.cy - z.y) / z.s;
      z.s = ns; z.x = mx - b.cx - ns * px; z.y = my - b.cy - ns * py;
      if (ns === 1) { z.x = 0; z.y = 0; }
      clampZ(); zPaint(glide);
    };
    const resetZ = (glide) => { z.s = 1; z.x = 0; z.y = 0; if (vImg) zPaint(glide); };
    const pageImg = (i) => shots[i]?.querySelector('img.vp-img');
    const onScreen = (r) => r.width > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    /* the morph: the zoom screen's photo starts (or ends) exactly over the page photo */
    const zMorph = (from, back) => {
      const a = from.getBoundingClientRect(), b = vImg.getBoundingClientRect();
      if (zStill() || !onScreen(a) || !b.width) return null;
      const k = a.width / b.width, dx = a.left + a.width / 2 - (b.left + b.width / 2), dy = a.top + a.height / 2 - (b.top + b.height / 2);
      const there = `translate(${dx}px,${dy}px) scale(${k})`, here = vImg.style.transform || 'none';
      const ms = back ? 200 : 300, easing = back ? EASE_MOVE : EASE_IN;
      from.style.visibility = 'hidden';
      const run = vImg.animate([{ transform: back ? here : there }, { transform: back ? there : here }], { duration: ms, easing });
      vShade.animate([{ opacity: back ? getComputedStyle(vShade).opacity : 0 }, { opacity: back ? 0 : 1 }], { duration: ms, easing });
      vUi.animate([{ opacity: back ? 1 : 0 }, { opacity: back ? 0 : 1 }], { duration: back ? 120 : ms, easing });
      return run.finished.catch(() => {}).then(() => { if (!back) from.style.visibility = ''; });
    };
    const zFade = (back) => {
      const ms = zStill() ? 100 : back ? 150 : 200;
      const run = viewer.animate([{ opacity: back ? 1 : 0 }, { opacity: back ? 0 : 1 }], { duration: ms, easing: zStill() ? 'linear' : back ? 'cubic-bezier(.3,0,1,1)' : EASE_IN });
      return run.finished.catch(() => {});
    };
    const viewShut = async () => {
      if (!viewer?.open || busy) return;
      busy = true;
      const i = slides.indexOf(shots[viewAt]);
      if (!gridMode() && i >= 0 && i !== cur) go(i, true);
      const from = pageImg(viewAt), done = from ? zMorph(from, true) : null;
      await (done || zFade(true));
      if (from) from.style.visibility = '';
      viewer.close();
      busy = false;
    };
    const viewBuild = () => {
      const d = document.createElement('dialog');
      d.className = 'vp-view'; d.setAttribute('aria-label', 'Photos');
      d.innerHTML = '<div class="vp-view-shade"></div><div class="vp-view-stage"><img class="vp-view-img" alt="" draggable="false"></div><div class="vp-view-ui"><button type="button" class="vp-view-x" aria-label="Close" autofocus><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><button type="button" class="vp-view-arrow" data-d="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.5 4.5-7.5 7.5 7.5 7.5"/></svg></button><button type="button" class="vp-view-arrow" data-d="1" aria-label="Next photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 4.5 7.5 7.5-7.5 7.5"/></svg></button><div class="vp-view-thumbs" role="group" aria-label="All photos"></div><p class="vp-view-n" aria-live="polite"></p></div>';
      vImg = d.querySelector('.vp-view-img'); vStage = d.querySelector('.vp-view-stage'); vShade = d.querySelector('.vp-view-shade'); vUi = d.querySelector('.vp-view-ui');
      const thumbs = d.querySelector('.vp-view-thumbs');
      shots.forEach((s, k) => {
        const from = s.querySelector('img.vp-img'), b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', `Photo ${k + 1} of ${shots.length}`);
        b.innerHTML = '<img alt="" loading="lazy" width="56" height="56" draggable="false">';
        b.firstChild.src = fileAt(from, 160, true);
        b.addEventListener('click', () => view(k));
        thumbs.append(b);
      });
      /* mouse: a click zooms 2.5x and the photo follows the pointer; a second click zooms out */
      const zFollow = (e) => { const b = zBox(); z.x = (1 - z.s) * (e.clientX - b.cx); z.y = (1 - z.s) * (e.clientY - b.cy); clampZ(); zPaint(false); };
      vImg.addEventListener('click', (e) => {
        e.stopPropagation();
        if (lastType !== 'mouse') return;
        if (z.s > 1.01) resetZ(true); else { z.s = 2.5; zFollow(e); zPaint(true); }
      });
      vImg.addEventListener('mousemove', (e) => { if (z.s > 1.01 && !vImg.classList.contains('is-gliding')) zFollow(e); });
      vImg.addEventListener('transitionend', () => vImg.classList.remove('is-gliding'));
      /* trackpad pinch (ctrl + wheel) zooms at the pointer */
      d.addEventListener('wheel', (e) => { if (!e.ctrlKey) return; e.preventDefault(); zoomAt(z.s * Math.exp(-e.deltaY / 100), e.clientX, e.clientY, false); }, { passive: false });
      /* touch: pinch, drag, double tap, swipe between photos, drag down to close */
      const pts = new Map(); let g = null, lastTap = 0, lastX = 0, lastY = 0;
      const mid = () => { const [a, b] = [...pts.values()]; return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, d: Math.hypot(a.x - b.x, a.y - b.y) }; };
      d.addEventListener('pointerdown', (e) => { lastType = e.pointerType || 'mouse'; }, true);
      vStage.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        vStage.setPointerCapture?.(e.pointerId);
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        vImg.classList.remove('is-gliding');
        if (pts.size === 2) { const m = mid(); g = { kind: 'pinch', s: z.s, m, px: (m.x - zBox().cx - z.x) / z.s, py: (m.y - zBox().cy - z.y) / z.s }; }
        else if (pts.size === 1) g = { kind: 'drag', x0: e.clientX, y0: e.clientY, zx: z.x, zy: z.y, t: performance.now(), axis: '' };
      });
      vStage.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (!g) return;
        if (g.kind === 'pinch' && pts.size === 2) {
          const m = mid(), b = zBox(), s = Math.min(MAX, Math.max(.85, g.s * m.d / g.m.d));
          z.s = s; z.x = m.x - b.cx - s * g.px; z.y = m.y - b.cy - s * g.py; if (s >= 1) clampZ(); zPaint(false);
        } else if (g.kind === 'drag' && pts.size === 1) {
          const dx = e.clientX - g.x0, dy = e.clientY - g.y0;
          if (z.s > 1.01) { z.x = g.zx + dx; z.y = g.zy + dy; clampZ(); zPaint(false); return; }
          if (!g.axis && Math.hypot(dx, dy) > 8) g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : (dy > 0 ? 'down' : 'y');
          if (g.axis === 'x') { z.x = dx; zPaint(false); }
          if (g.axis === 'down') { z.y = dy; z.x = dx * .4; zPaint(false); vShade.style.opacity = String(Math.max(.2, 1 - dy / 400)); vUi.style.opacity = String(Math.max(0, 1 - dy / 160)); }
        }
      });
      const lift = (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.delete(e.pointerId);
        if (!g) return;
        if (g.kind === 'pinch') {
          if (pts.size === 1) { const [p] = [...pts.values()]; g = { kind: 'drag', x0: p.x, y0: p.y, zx: z.x, zy: z.y, t: performance.now(), axis: 'pan' }; }
          else g = null;
          if (z.s < 1.01) resetZ(true); else { clampZ(); zPaint(true); }
          return;
        }
        if (pts.size) return;
        const dx = e.clientX - g.x0, dy = e.clientY - g.y0, fast = performance.now() - g.t < 260, moved = Math.hypot(dx, dy) > 10, kind = g.axis; g = null;
        if (z.s > 1.01 && moved) return;
        if (kind === 'down' && (dy > 110 || (fast && dy > 40))) { viewShut(); return; }
        vShade.style.opacity = ''; vUi.style.opacity = '';
        if (kind === 'x' && (Math.abs(dx) > 70 || (fast && Math.abs(dx) > 30))) {
          const to = viewAt + (dx < 0 ? 1 : -1);
          if (shots[to]) { slideTo(to, dx < 0 ? 1 : -1); return; }
        }
        if (kind && kind !== 'pan' && z.s <= 1.01) { resetZ(true); return; }
        if (moved) return;
        /* a tap: two quick taps toggle 2.5x at that spot */
        const now = performance.now();
        if (now - lastTap < 300 && Math.hypot(e.clientX - lastX, e.clientY - lastY) < 30) { lastTap = 0; if (z.s > 1.01) resetZ(true); else zoomAt(2.5, e.clientX, e.clientY, true); }
        else { lastTap = now; lastX = e.clientX; lastY = e.clientY; }
      };
      vStage.addEventListener('pointerup', lift); vStage.addEventListener('pointercancel', lift);
      vStage.addEventListener('click', (e) => { if (e.target === vStage && lastType === 'mouse') viewShut(); });
      d.querySelector('.vp-view-x').addEventListener('click', viewShut);
      d.querySelectorAll('.vp-view-arrow').forEach((b) => b.addEventListener('click', () => view(viewAt + +b.dataset.d)));
      d.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); view(viewAt + (e.key === 'ArrowLeft' ? -1 : 1)); }
      });
      d.addEventListener('cancel', (e) => { e.preventDefault(); viewShut(); });
      d.addEventListener('close', () => {
        resetZ(false); vShade.style.opacity = ''; vUi.style.opacity = '';
        (zOpener && zOpener.isConnected ? zOpener : shots[viewAt]).focus(quietFocus());
        zOpener = null;
      });
      /* Escape closes it with its own motion, before the theme's page-wide Escape (which closes any dialog at once) */
      addEventListener('keydown', (e) => { if (e.key === 'Escape' && d.open) { e.preventDefault(); e.stopImmediatePropagation(); viewShut(); } }, true);
      d.classList.toggle('vp-view--one', shots.length < 2);
      el.append(d);
      return d;
    };
    /* put photo i in the zoom screen: the page's file at once, the full-quality file when it arrives */
    const zPlace = (i) => {
      viewAt = i;
      const d = viewer, from = pageImg(i);
      const bg = shots[i].dataset.bg || getComputedStyle(el).getPropertyValue('--vp-grey').trim(), w = +from.getAttribute('width') || from.naturalWidth, h = +from.getAttribute('height') || from.naturalHeight;
      resetZ(false);
      d.style.setProperty('--vp-view-bg', bg); d.style.setProperty('--vp-view-ink', dark(bg) ? '#fbf9f6' : '#292824');
      vImg.style.setProperty('--ar', w && h ? w / h : 1);
      vImg.alt = from.alt; vImg.src = from.currentSrc || from.src;
      const done = shots[i].vpDeep, big = done && done !== 'loading' ? done : sharp(from), pre = new Image(); pre.onload = () => { if (viewAt === i && d.open && !(shots[i].vpDeep && shots[i].vpDeep !== 'loading' && vImg.src === shots[i].vpDeep)) vImg.src = big; }; pre.src = big;
      d.querySelector('.vp-view-n').textContent = `${i + 1} / ${shots.length}`;
      const [prev, next] = d.querySelectorAll('.vp-view-arrow');
      prev.disabled = i === 0; next.disabled = i === shots.length - 1;
      d.querySelectorAll('.vp-view-thumbs button').forEach((b, k) => { b.classList.toggle('on', k === i); k === i ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current'); if (k === i) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: zStill() ? 'auto' : 'smooth' }); });
      return vImg.decode ? vImg.decode().catch(() => {}) : Promise.resolve();
    };
    /* follow a pinch that began on the page; let go: back to the page if the fingers closed, else stay zoomed (at least fitted) */
    const handFollow = (h) => {
      if (!h.ready || !h.m || !viewer?.open) return;
      const b = zBox(), s = Math.min(MAX, Math.max(h.s0 * .6, h.s0 * h.m.d / h.m0.d));
      z.s = s; z.x = h.m.x - b.cx - s * h.px; z.y = h.m.y - b.cy - s * h.py;
      if (s >= 1) clampZ();
      zPaint(false);
    };
    const handSettle = (h) => {
      if (!viewer?.open) return;
      const restore = () => { if (h.page) h.page.style.visibility = ''; };
      if (z.s < h.s0 * .9) { restore(); viewShut(); return; }
      if (z.s < 1) resetZ(true); else { clampZ(); zPaint(true); }
      setTimeout(restore, 220);
    };
    /* a swipe: the photo leaves to one side and the next one comes in from the other */
    const slideTo = async (i, dir) => {
      if (busy) return; busy = true;
      if (!zStill()) await vImg.animate([{ transform: vImg.style.transform || 'none' }, { transform: `translateX(${-dir * innerWidth * .6}px)`, opacity: 0 }], { duration: 150, easing: 'cubic-bezier(.3,0,1,1)' }).finished.catch(() => {});
      await zPlace(i);
      if (!zStill()) await vImg.animate([{ transform: `translateX(${dir * innerWidth * .3}px)`, opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 200, easing: EASE_IN }).finished.catch(() => {});
      busy = false;
    };
    const view = async (i, from, pinch) => {
      if (!shots[i] || busy) return;
      if (viewer?.open) { if (i !== viewAt) await zPlace(i); return; }
      busy = true;
      zOpener = from || document.activeElement;
      viewer = viewer || viewBuild();
      await zPlace(i);
      viewer.showModal();
      if (document.activeElement?.disabled) viewer.querySelector('.vp-view-x').focus(quietFocus());
      const page = pageImg(i);
      if (pinch && page && !zStill() && !pinch.done) {
        /* the pinch carries on: the photo starts exactly where it sat on the page and follows the same two fingers */
        const a = page.getBoundingClientRect(), b = vImg.getBoundingClientRect(), bx = zBox();
        z.s = a.width / b.width; z.x = a.left + a.width / 2 - (b.left + b.width / 2); z.y = a.top + a.height / 2 - (b.top + b.height / 2); zPaint(false);
        page.style.visibility = 'hidden';
        Object.assign(pinch, { s0: z.s, px: (pinch.m0.x - bx.cx - z.x) / z.s, py: (pinch.m0.y - bx.cy - z.y) / z.s, page, ready: true });
        vShade.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: EASE_IN });
        vUi.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: EASE_IN });
        handFollow(pinch);
        if (pinch.done) handSettle(pinch);
        busy = false;
        [i - 1, i + 1].forEach((k) => { if (shots[k]) new Image().src = sharp(pageImg(k)); });
        return;
      }
      const done = page ? zMorph(page, false) : null;
      await (done || zFade(false));
      busy = false;
      /* the neighbours' full-quality files, so the next photo is sharp at once */
      [i - 1, i + 1].forEach((k) => { if (shots[k]) new Image().src = sharp(pageImg(k)); });
    };
    const curShot = () => { const k = shots.indexOf(slides[cur]); return k >= 0 ? k : Math.max(0, shots.findIndex((s) => slides.indexOf(s) > cur)); };
    if (zoomBtn) { if (shots.length) zoomBtn.addEventListener('click', () => view(curShot(), zoomBtn)); else zoomBtn.hidden = true; }
    /* a pinch on a page photo opens the zoom screen at that photo instead of zooming the page */
    const shotOf = (t) => { const s = t.closest?.('.vp-slide'); const k = shots.indexOf(s); return k >= 0 ? k : curShot(); };
    if (track && shots.length) {
      /* the two fingers stay on the page's photo strip, so their moves arrive here even while the zoom screen is open */
      let hand = null, held = false;
      const two = (t) => ({ x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2, d: Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY) || 1 });
      track.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 2 || window.Shopify?.designMode) return;
        e.preventDefault(); held = true;
        if (hand || viewer?.open) return;
        hand = { m0: two(e.touches), m: null, ready: false, done: false };
        view(shotOf(e.target), null, hand);
      }, { passive: false });
      track.addEventListener('touchmove', (e) => {
        if (!held) return;
        e.preventDefault();
        if (hand && e.touches.length >= 2) { hand.m = two(e.touches); handFollow(hand); }
      }, { passive: false });
      const lift2 = (e) => {
        if (hand && e.touches.length < 2) { const h = hand; hand = null; h.done = true; if (h.ready) handSettle(h); }
        if (!e.touches.length) held = false;
      };
      track.addEventListener('touchend', lift2); track.addEventListener('touchcancel', lift2);
      track.addEventListener('gesturestart', (e) => e.preventDefault());
      track.addEventListener('wheel', (e) => { if (e.ctrlKey && e.deltaY < 0 && !window.Shopify?.designMode) { e.preventDefault(); view(shotOf(e.target)); } }, { passive: false });
    }
    const armViewer = () => shots.forEach((s, k) => {
      const img = s.querySelector('img.vp-img'), n = k + 1;
      const on = wide.matches && !window.Shopify?.designMode;
      s.classList.toggle('vp-zoomable', on);
      if (on) { s.tabIndex = gridMode() || slides[cur] === s ? 0 : -1; s.setAttribute('role', 'button'); s.setAttribute('aria-haspopup', 'dialog'); s.setAttribute('aria-label', `${img.alt ? img.alt + '. ' : ''}Enlarge photo ${n} of ${shots.length}`); }
      else ['tabindex', 'role', 'aria-haspopup', 'aria-label'].forEach((a) => s.removeAttribute(a));
    });
    shots.forEach((s, k) => {
      s.addEventListener('click', (e) => { if (s.classList.contains('vp-zoomable') && !e.target.closest('a,button,video,iframe')) view(k, s); });
      s.addEventListener('keydown', (e) => { if (s.classList.contains('vp-zoomable') && e.target === s && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); view(k, s); } });
    });
    armViewer(); wide.addEventListener('change', armViewer);
    /* Gallery videos start only after the slide is substantially visible, including page scroll and
       horizontal swipes. A tap or keyboard action pauses/resumes without covering the picture. */
    const videos = $$('.vp-slide video.vp-autoplay');
    if (videos.length) {
      const reduced = matchMedia('(prefers-reduced-motion: reduce)'), visible = new Map();
      let autoVideo = null, manualVideo = null;
      const syncVideos = () => {
        const away = (video) => document.hidden || (visible.get(video) || 0) < .55;
        videos.forEach((video) => { if (away(video)) video.pause(); });
        if (manualVideo && away(manualVideo)) manualVideo = null;
        if (document.hidden || reduced.matches || el.hasAttribute('data-vp-hold')) {
          if (autoVideo) autoVideo.pause();
          autoVideo = null;
          return;
        }
        if (manualVideo) return; // A shopper's play/pause choice owns the visible video until it leaves view.
        const best = videos.reduce((a, b) => (visible.get(b) || 0) > (visible.get(a) || 0) ? b : a);
        const next = (visible.get(best) || 0) >= .55 ? best : null;
        if (next === autoVideo) return;
        if (autoVideo) autoVideo.pause();
        autoVideo = next;
        if (next) {
          next.muted = true;
          const playing = next.play();
          if (playing) playing.catch(() => { /* The poster stays visible; a shopper can tap to retry. */ });
        }
      };
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => visible.set(entry.target, entry.intersectionRatio));
        syncVideos();
      }, { threshold: [0, .55, 1] });
      videos.forEach((video) => {
        visible.set(video, 0);
        video.tabIndex = 0;
        video.setAttribute('role', 'button');
        const paintVideoAction = () => video.setAttribute('aria-label', video.paused ? 'Play product video' : 'Pause product video');
        const toggleVideo = () => {
          if (video.paused) {
            const playing = video.play();
            if (playing) playing.catch(() => { /* Keep the video available for another tap if playback is refused. */ });
          } else video.pause();
        };
        let pointerStart = null, dragged = false;
        video.addEventListener('pointerdown', (e) => { pointerStart = [e.clientX, e.clientY]; dragged = false; });
        video.addEventListener('pointermove', (e) => {
          if (pointerStart && Math.hypot(e.clientX - pointerStart[0], e.clientY - pointerStart[1]) > 10) dragged = true;
        });
        video.addEventListener('pointercancel', () => { pointerStart = null; dragged = true; });
        video.addEventListener('click', (e) => {
          e.preventDefault();
          if (!dragged) toggleVideo();
          pointerStart = null; dragged = false;
        });
        video.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleVideo(); }
        });
        video.addEventListener('pause', paintVideoAction);
        video.addEventListener('play', () => {
          paintVideoAction();
          if (video !== autoVideo) { manualVideo = video; autoVideo = null; }
          videos.forEach((other) => { if (other !== video) other.pause(); });
        });
        paintVideoAction();
        /* The cover (snippets/vp-slide.liquid): the poster stays laid over the video until the video has put its first
           frame on screen, then fades in 100 ms. Safari drops a video's own poster as soon as playback is asked for, which
           left the slide empty for a third of a second (founder 2026-10-14: "a flash before it plays"). If the file ever
           empties or fails, the cover comes back, so the slide never stands blank. */
        const cover = video.parentNode && video.parentNode.querySelector(':scope > .vp-poster');
        if (cover) {
          let waiting = false;
          const shown = () => { waiting = false; cover.classList.add('is-off'); };
          const watchFirstFrame = () => {
            if (waiting) return; waiting = true;
            if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(shown);
            else video.addEventListener('playing', () => requestAnimationFrame(shown), { once: true });
          };
          watchFirstFrame();
          video.addEventListener('emptied', () => { cover.classList.remove('is-off'); waiting = false; watchFirstFrame(); });
          video.addEventListener('error', () => cover.classList.remove('is-off'), true);
        }
        video.controls = false;
        videoObserver.observe(video);
      });
      document.addEventListener('visibilitychange', syncVideos);
      reduced.addEventListener('change', syncVideos);
      if (el.hasAttribute('data-vp-hold')) {
        const holdObserver = new MutationObserver(() => {
          if (!el.hasAttribute('data-vp-hold')) { holdObserver.disconnect(); syncVideos(); }
        });
        holdObserver.observe(el, { attributes: true, attributeFilter: ['data-vp-hold'] });
      }
    }
    /* variants */
    const data = $('[data-vp-variants]'), idIn = $('[data-vp-id]'), smartPhoto = $('.vp-smart img');
    const vs = data ? JSON.parse(data.textContent) : [];
    let v = vs.find((x) => String(x.id) === idIn?.value) || vs[0];
    const pills = $$('.vp-pill[data-opt]');
    /* The shopper chooses the size (founder 2026-10-08): an option row marked data-vp-must starts with nothing chosen.
       The form still carries a whole variant (the page's own first choice), so without this script Add to bag adds
       it, as before; with it, Add to bag asks for the size first (below). */
    const must = new Map($$('[data-vp-must]').map((n) => [+n.dataset.vpMust, n]));
    const chosen = new Set(), picked = (o) => !must.has(o) || chosen.has(o);
    const paint = () => {
      if (!v) return;
      idIn.value = v.id;
      pills.forEach((p) => {
        const o = +p.dataset.opt, val = p.dataset.val;
        p.setAttribute('aria-pressed', String(picked(o) && v.o[o] === val));
        const alt = vs.find((x) => x.o[o] === val && x.o.every((y, k) => k === o || y === v.o[k]));
        p.classList.toggle('na', !alt || !alt.a);
      });
      $$('[data-vp-optname]').forEach((n) => { n.textContent = v.o[+n.dataset.vpOptname]; const w = n.closest('[data-vp-optval]'); if (w) w.hidden = !picked(+n.dataset.vpOptname); });
      /* prices are the shop's own money format, the markup the server prints: in dollars it is
         <span class=trans-money>$55.00</span>, so it goes in as markup (as text it showed the tags) */
      $$('[data-vp-price],[data-vp-price-mirror]').forEach((n) => { n.innerHTML = v.p; n.classList.toggle('is-sale', !!v.c && n.hasAttribute('data-vp-price')); });
      $$('[data-vp-compare]').forEach((n) => { n.hidden = !v.c; n.innerHTML = v.c || ''; });
      if (smartPhoto && v.t && smartPhoto.getAttribute('src') !== v.t) {
        smartPhoto.removeAttribute('srcset');
        smartPhoto.removeAttribute('sizes');
        smartPhoto.loading = 'eager';
        smartPhoto.src = v.t;
      }
      $$('[data-vp-add]').forEach((b) => {
        b.disabled = !v.a;
        const l = b.querySelector('[data-vp-add-label]'), row = $('.vp-buyrow [data-vp-add]');
        const add = (row && row.dataset.add) || 'Add to bag', sold = (row && row.dataset.sold) || 'Sold out';
        const short = b.hasAttribute('data-vp-short') || (row && row.hasAttribute('data-vp-noprice'));
        if (l) { l.textContent = v.a ? (short ? add : add + ' · ') : sold; if (v.a && !short) l.insertAdjacentHTML('beforeend', v.p); }
      });
    };
    /* each option row's name as shown (its group label), for the size memory */
    const names = [];
    pills.forEach((p) => { const r = p.closest('.vp-rail'); if (r && names[+p.dataset.opt] == null) names[+p.dataset.opt] = r.getAttribute('aria-label'); });
    /* One path updates the selected variant, price, Add to bag and address. The carousel follows the variant's
       photo; Grid keeps the page and visible-photo marker steady for size taps and size memory. Only an explicit
       colour tap moves Grid to its assigned photo. Memory requests a changed image at once without page motion. */
    const choose = (x, memo, colourTap = false) => {
      const was = v; v = x; paint();
      /* the address names the variant only once every option is the shopper's own: a link naming a size she never
         chose would open with that size chosen */
      if ([...must.keys()].every(picked)) try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
      if (!v.m || (memo && v.m === was.m)) return;
      const i = slides.findIndex((s) => +s.dataset.pos === v.m); if (i < 0) return;
      if (memo) { const im = slides[i].querySelector('img'); if (im) im.loading = 'eager'; }
      // Grid keeps its marker on the photo actually in view unless the shopper chose a colour.
      if (gridMode() && !colourTap) return;
      go(i, memo, colourTap);
    };
    const tap = (p, trusted) => {
      const o = +p.dataset.opt, want = v.o.slice(); want[o] = p.dataset.val;
      if (trusted) remember(names[o], p.dataset.val);
      chosen.add(o); hush(o);
      const same = (x) => x.o[o] === want[o];
      /* an option she has not chosen yet bends to one that can be bought (a colour tap never lands on "Sold out"
         because of a size she never picked); with every option chosen this is the exact variant, as before */
      const fits = (x) => x.a && x.o.every((y, k) => (k === o || picked(k) ? y === want[k] : true));
      const colourTap = !!p.closest('[data-vp-colour]');
      /* A size (any option but colour) chosen with Add to bag below the screen nudges the page down just enough to
         show it (founder 2026-10-08); never up, never when it already shows, never behind the size sheet. */
      if (trusted && !colourTap && !document.querySelector('.vp-sheet[open]')) requestAnimationFrame(() => {
        const add = pageAdd(); if (!add) return;
        const r = add.getBoundingClientRect(), over = Math.round(r.bottom + 12 - innerHeight);
        if (over > 0 && r.top > 0) window.scrollBy({ top: over, behavior: motion() });
      });
      choose(vs.find((x) => x.a && x.o.every((y, k) => y === want[k])) || vs.find(fits) || vs.find((x) => x.o.every((y, k) => y === want[k])) || vs.find((x) => same(x) && x.a) || vs.find(same) || v, false, colourTap);
    };
    pills.forEach((p) => p.addEventListener('click', (e) => tap(p, e.isTrusted)));
    /* Add to bag with a size still unchosen (founder 2026-10-08, like Pandora): nothing is added. A sheet slides up
       from the bottom, titled with the row's message ("Choose your size"), holding that row's values as the page shows
       them for the chosen colour (sold-out ones crossed out and not tappable). Tapping one chooses it on the page too
       (the page's own tap path: row, price, address, size memory) and adds at once, as Pandora's sheet does: the sheet
       leaves, then this one form is sent with the button she pressed, so the Interactopus cart catches it as always.
       Closing it (the cross, the dim area, Escape, a drag down) adds nothing and leaves the row's name and message in
       the message colour. Both buttons, the page's own and the slim bar's, submit this one form; the guard runs first
       (window, capture), so the cart and the button's "Adding" never see the press. A row she cannot see (the options
       block shown on the other device only) never blocks: the page's own choice is added, as before. The sheet is a
       native <dialog> built on first use inside the row's own block (it takes the block's pill look); its motion is the
       header's phone menu's (voisson-product.css). */
    const needs = () => [...must.entries()].filter(([o, n]) => !chosen.has(o) && n.getClientRects().length);
    const hush = (o) => { const n = must.get(o); if (!n) return; n.classList.remove('is-need'); const m = n.querySelector('[data-vp-need]'); if (m) m.textContent = ''; };
    const form = idIn?.form, calm = matchMedia('(prefers-reduced-motion: reduce)'), sheets = new Map();
    let opener = null, sending = false;
    const shut = (s, add) => {
      if (!s.open || s.classList.contains('is-closing')) return;
      sending = !!add; s.classList.remove('is-dragging'); s.classList.add('is-closing');
      setTimeout(() => s.close(), calm.matches ? 100 : 150);
    };
    const fill = (s, row) => {
      const msg = row.querySelector('[data-vp-need]'), rail = row.querySelector('.vp-rail'), sold = $('.vp-buyrow [data-vp-add]')?.dataset.sold || 'Sold out';
      s.querySelector('.vp-sheet-t').textContent = msg ? msg.dataset.vpNeed : rail.getAttribute('aria-label');
      const opts = s.querySelector('.vp-sheet-opts'); opts.setAttribute('aria-label', rail.getAttribute('aria-label'));
      opts.replaceChildren(...[...rail.querySelectorAll('.vp-pill')].map((p) => {
        const b = document.createElement('button'), na = p.classList.contains('na');
        b.type = 'button'; b.className = 'vp-pill' + (na ? ' na' : ''); b.dataset.val = p.dataset.val; b.innerHTML = p.innerHTML; b.disabled = na;
        if (na) b.setAttribute('aria-label', p.dataset.val + ', ' + sold);
        return b;
      }));
    };
    const sheetFor = (row) => {
      if (sheets.has(row)) return sheets.get(row);
      const s = document.createElement('dialog'), id = 'vp-sheet-' + row.dataset.vpMust + '-' + (form.id || '');
      s.className = 'vp-sheet'; s.setAttribute('aria-labelledby', id);
      s.innerHTML = '<div class="vp-sheet-grab" aria-hidden="true"></div><div class="vp-sheet-head"><h2 class="vp-sheet-t"></h2><button type="button" class="vp-sheet-x"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="vp-sheet-opts" role="group"></div>';
      s.querySelector('.vp-sheet-t').id = id;
      s.querySelector('.vp-sheet-x').setAttribute('aria-label', row.querySelector('[data-vp-need]')?.dataset.vpClose || 'Close');
      (row.closest('.vp-variants') || row).append(s);
      s.querySelector('.vp-sheet-x').addEventListener('click', () => shut(s));
      s.addEventListener('click', (e) => { const r = s.getBoundingClientRect(); if (e.target === s && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) shut(s); });
      s.addEventListener('cancel', (e) => { e.preventDefault(); shut(s); });
      s.querySelector('.vp-sheet-opts').addEventListener('click', (e) => {
        const b = e.target.closest('button'), p = b && [...row.querySelectorAll('.vp-pill')].find((x) => x.dataset.val === b.dataset.val);
        if (!p || b.disabled || s.classList.contains('is-closing')) return;
        tap(p, e.isTrusted);
        const next = needs()[0];
        if (next) { const n = sheetFor(next[1]); if (n === s) return; s.close(); open(opener, next[1]); }
        else if (v && v.a) shut(s, true);
      });
      s.addEventListener('close', () => {
        s.classList.remove('is-closing', 'is-dragging'); s.style.removeProperty('--sh-y');
        const at = document.activeElement;
        if (opener && opener.isConnected && (!at || at === document.body || s.contains(at))) opener.focus(quietFocus());
        if (sending) { sending = false; const b = opener && opener.isConnected && !opener.disabled ? opener : $('.vp-buyrow [data-vp-add]'); if (form.requestSubmit) form.requestSubmit(b); else b.click(); return; }
        if (!chosen.has(+row.dataset.vpMust)) { row.classList.add('is-need'); const m = row.querySelector('[data-vp-need]'); if (m) m.textContent = m.dataset.vpNeed; }
      });
      /* A drag down (finger or pen) follows the finger; past a third of its height, or a quick flick, it closes,
         otherwise it springs back: the header menu's rule, turned to vertical. */
      let start = null, dy = 0, last = null, speed = 0, dragged = -1e4;
      s.addEventListener('pointerdown', (e) => { start = e.pointerType !== 'mouse' && e.isPrimary && !s.classList.contains('is-closing') ? [e.clientX, e.clientY] : null; dy = 0; speed = 0; last = [e.clientY, e.timeStamp]; });
      s.addEventListener('pointermove', (e) => {
        if (!start) return;
        const x = e.clientX - start[0], y = e.clientY - start[1];
        if (!s.classList.contains('is-dragging')) {
          if (Math.abs(x) < 10 && Math.abs(y) < 10) return;
          if (y < 0 || Math.abs(x) >= Math.abs(y)) { start = null; return; }
          s.classList.add('is-dragging');
        }
        dy = Math.max(0, y); speed = (e.clientY - last[0]) / Math.max(1, e.timeStamp - last[1]); last = [e.clientY, e.timeStamp];
        if (!calm.matches) s.style.setProperty('--sh-y', dy + 'px');
      });
      const release = (e) => {
        start = null;
        if (!s.classList.contains('is-dragging')) return;
        dragged = e.timeStamp;
        if (e.timeStamp - last[1] > 100) speed = 0;
        if (e.type === 'pointerup' && (dy > s.offsetHeight / 3 || speed > 0.5)) shut(s);
        else { s.classList.remove('is-dragging'); s.style.removeProperty('--sh-y'); }
      };
      s.addEventListener('pointerup', release); s.addEventListener('pointercancel', release);
      s.addEventListener('click', (e) => { if (e.timeStamp - dragged < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
      sheets.set(row, s);
      return s;
    };
    const open = (btn, row) => {
      opener = btn; sending = false;
      const s = sheetFor(row); fill(s, row);
      s.classList.remove('is-closing', 'is-dragging'); s.style.removeProperty('--sh-y');
      s.showModal();
      (s.querySelector('.vp-sheet-opts button:not(:disabled)') || s.querySelector('.vp-sheet-x')).focus(quietFocus());
    };
    const guard = (e) => {
      const t = e.type === 'submit' ? e.target : e.target.closest?.('[data-vp-add]');
      if (!t || (e.type === 'submit' ? t !== form : !el.contains(t)) || !needs().length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open(e.type === 'submit' ? e.submitter || $('.vp-buyrow [data-vp-add]') : t, needs()[0][1]);
    };
    /* Escape closes the sheet with its own motion, before the theme's page-wide Escape (which closes at once) */
    const esc = (e) => { if (e.key !== 'Escape') return; const s = [...sheets.values()].find((x) => x.open); if (s) { e.preventDefault(); e.stopImmediatePropagation(); shut(s); } };
    if (must.size && form) { addEventListener('click', guard, true); addEventListener('submit', guard, true); addEventListener('keydown', esc, true); }
    if (vs.length > 1) paint();
    /* The slim bar (founder 2026-10-08, like Pandora): "Smart" shows it only once the shopper has scrolled past the
       page's own Add to bag (the button wholly above the screen) and hides it again the moment any of that button is
       back in sight, so the two never show together; nothing shows before she reaches the button. "In place" shows it
       only while the button sits below the first screen. One observer, no scroll listener; the bar moves by transform
       only. While it shows, <html> carries vp-bar-on so the chat bubble steps up out of its way. */
    const bar = $('[data-vp-smart]'), row = $('.vp-buyrow [data-vp-add]');
    if (bar && row) {
      const btn = bar.querySelector('button'), below = el.classList.contains('vp--add-inplace');
      new IntersectionObserver(([e]) => {
        const r = e.boundingClientRect;
        const on = below ? e.intersectionRatio < .98 && r.top > 0 : !e.isIntersecting && r.bottom <= 0;
        bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', String(!on)); btn.tabIndex = on ? 0 : -1;
        document.documentElement.classList.toggle('vp-bar-on', on);
      }, { threshold: [0, .98] }).observe(row);
    }
    /* size memory, read once as the page opens. In the product's order, a remembered value is chosen only when this
       piece offers exactly that value and it can still be bought with the values chosen so far: the remembered ones
       before it, and the page's own choice for every earlier option without one (never a sold-out value, never a change
       to an option she did not pick). Later options keep the page's own choice wherever it can be bought with them.
       Never over a ?variant= link, through a picker she cannot see, in the theme editor, or once she has tapped or
       pressed a key on THIS page (the browser's record of the page's first input: a slow phone shows the page before
       this script runs, and a tap made then must not be overridden). Not navigator.userActivation: Chrome carries it
       over from the link she tapped on the previous page (measured 2026-09-27), which would switch the memory off.
       Shown through choose(), the tap's own path, without a synthetic click (other scripts listening to clicks, such as
       the menu closing on any click, never see one); then a chosen pill further along a sliding row is brought into
       view in its row (the page stays put). Choosing writes nothing. A page Chrome prerendered reads the memory when it
       is shown (its storage is a copy until then). */
    const recall = () => {
      try {
        if (performance.getEntriesByType('first-input').length || window.Shopify?.designMode || !v || vs.length < 2 || !pills.some((p) => p.getClientRects().length) || new URL(location.href).searchParams.has('variant')) return;
        const mem = memory(), got = [];
        v.o.forEach((_, k) => { const val = mem[names[k]]; if (ok60(names[k], val) && vs.some((x) => x.a && x.o[k] === val && x.o.every((y, j) => j >= k || y === (got[j] != null ? got[j] : v.o[j])))) got[k] = val; });
        const fits = (x) => got.every((s, j) => s == null || x.o[j] === s);
        const can = vs.filter((x) => x.a && fits(x));
        if (!got.some((s) => s != null) || !can.length) return;
        const keep = (x) => x.o.reduce((n, y, j) => n * 2 + (got[j] == null && y === v.o[j] ? 1 : 0), 0);
        const t = can.reduce((b, x) => (keep(x) > keep(b) ? x : b));
        /* a remembered size is her own earlier choice: it counts as chosen, so Add to bag does not ask again */
        got.forEach((s, k) => { if (s != null) { chosen.add(k); hush(k); } });
        if (t === v) { paint(); return; } // the memory is the page's own choice already: it shows as chosen, the address stays as it is
        choose(t, true);
        $$('.vp-rail').forEach((r) => { const p = r.querySelector('.vp-pill[aria-pressed="true"]'); if (!p) return; const a = r.getBoundingClientRect(), b = p.getBoundingClientRect(); if (b.left < a.left || b.right > a.right) r.scrollLeft += b.left - a.left - (a.width - b.width) / 2; });
      } catch (e) { /* no memory: the page's own choice stands */ }
    };
    if (document.prerendering) document.addEventListener('prerenderingchange', recall, { once: true }); else recall();
  };
  /* Read more (description "Open, first lines then Read more", 2026-10-08). The whole text is in the markup; this cuts it
     to --cl lines and shows the button only when the text is longer. Read less keeps the button under the finger. */
  const clamp = (box) => {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    const btn = box.nextElementSibling; if (!btn || !btn.matches('[data-vp-more]')) return;
    let open = false;
    const more = btn.textContent, less = btn.dataset.less || more;
    const d = box.closest('details');
    const fit = () => {
      if (open || (d && !d.open) || !box.offsetParent) return;
      const lh = parseFloat(getComputedStyle(box.querySelector('p') || box).lineHeight) || 24;
      const n = parseInt(getComputedStyle(box).getPropertyValue('--cl'), 10) || 4;
      box.classList.remove('is-cl'); box.style.maxHeight = '';
      const cut = box.scrollHeight > n * lh + 4;
      if (cut) { box.style.setProperty('--clh', lh + 'px'); box.style.maxHeight = n * lh + 'px'; box.classList.add('is-cl'); }
      btn.hidden = !cut;
    };
    btn.addEventListener('click', () => {
      const before = btn.getBoundingClientRect().top;
      open = !open;
      btn.setAttribute('aria-expanded', open); btn.textContent = open ? less : more;
      if (open) { box.classList.remove('is-cl'); box.style.maxHeight = ''; } else { fit(); window.scrollBy(0, btn.getBoundingClientRect().top - before); }
    });
    if (d) d.addEventListener('toggle', fit);
    fits.add(fit); fit(); if (document.fonts) document.fonts.ready.then(fit);
  };
  const fits = new Set(); let fitW = innerWidth;
  addEventListener('resize', () => { if (innerWidth === fitW) return; fitW = innerWidth; fits.forEach((f) => f()); });
  const all = () => { document.querySelectorAll('[data-vp]').forEach(init); document.querySelectorAll('[data-vp-clamp]').forEach(clamp); };
  all();
  document.addEventListener('shopify:section:load', all);
})();
